module.exports = __webpack_public_path__ + "img/c-class-sport-sedan.2353823c.jpg";